import { useBoolean } from '@chakra-ui/react';
import React, { createContext, useState } from 'react';
import { SelectItem } from '~/types';
import { FilterContextData, FilterGroups } from './types';

export const FilterContext = createContext<FilterContextData>(
  {} as FilterContextData,
);

export const FilterProvider: React.FC = ({ children }) => {
  const [groups, setGroups] = useState<SelectItem[]>([]);
  const [branches, setBranches] = useState<SelectItem[]>([]);
  const [headOffices, setHeadOffices] = useState<SelectItem[]>([]);
  const [isActive, setIsActive] = useBoolean(false);

  const clearL = () => {
    setGroups([]);
    setBranches([]);
    setHeadOffices([]);
    setIsActive.off();
  };

  const apply = ({ newgroups, newheadOffices, newbranches }: FilterGroups) => {
    if (
      newgroups.length === 0 &&
      newheadOffices.length === 0 &&
      newbranches.length === 0
    )
      clearL();
    else {
      setGroups(newgroups);
      setBranches(newbranches);
      setHeadOffices(newheadOffices);
      setIsActive.on();
    }
  };

  return (
    <FilterContext.Provider
      value={{ apply, groups, branches, headOffices, isActive }}
    >
      {children}
    </FilterContext.Provider>
  );
};
